import { atom } from 'jotai';

/**
 * API 호출에 keepalive 적용 여부
 */
export const isUseKeepAliveAtom = atom(false);
